import { UseFormRegisterReturn } from 'react-hook-form';
import { MenuItem, TextField } from '@mui/material';
import { NEW_SERVICE_REQUEST, typeOfRequestValues } from './serviceRequestModel';

interface RequestTypeFieldProps {
  disabled: boolean;
  registration: UseFormRegisterReturn;
}

/** The Type of Request select, registered with the form so its change also resets the picks that depend on it. */
export function RequestTypeField({ disabled, registration }: RequestTypeFieldProps) {
  return (
    <div style={{ breakInside: 'avoid', marginBottom: '1.5rem' }}>
      <TextField
        select
        required
        disabled={disabled}
        sx={{ width: '100%' }}
        label="Type of Request"
        id="request_type_select"
        defaultValue={NEW_SERVICE_REQUEST}
        data-cy="request_type"
        size="small"
        aria-label="type of request"
        {...registration}>
        {typeOfRequestValues.map((value) => (
          <MenuItem
            key={value}
            value={value}>
            {value}
          </MenuItem>
        ))}
      </TextField>
    </div>
  );
}
